import { addCourseToCandidate } from "./addCourseToCandidate";
import { addEducationToCandidate } from "./addEducationToCandidate";
import { addExperienceToCandidate } from "./addExperienceToCandidate";
import { addKnowledgeToCandidate } from "./addKnowledgeToCandidate";
import { addPositionWishToCandidate } from "./addPositionWishToCandidate";
import { attachCandidateToCase } from "./attachCandidateToCase";
import { editCourseForCandidate } from "./editCourseForCandidate";
import { editEducationForCandidate } from "./editEducationForCandidate";
import { editExperienceForCandidate } from "./editExperienceForCandidate";
import { editKnowledgeForCandidate } from "./editKnowledgeForCandidate";
import { editPositionWishForCandidate } from "./editPositionWishForCandidate";
import { getCoursesForCandidate } from "./getCoursesForCandidate";
import { getDetailsForCandidate } from "./getDetailsForCandidate";
import { getEducationForCandidate } from "./getEducationForCandidate";
import { getExperienceForCandidate } from "./getExperienceForCandidate";
import { getKnowledgeForCandidate } from "./getKnowledgeForCandidate";
import { removeCourseFromCandidate } from "./removeCourseFromCandidate";
import { removeEducationFromCandidate } from "./removeEducationFromCandidate";
import { removeExperienceFromCandidate } from "./removeExperienceFromCandidate";
import { removeKnowledgeByTypeFromCandidate } from "./removeKnowledgeByTypeFromCandidate";
import { removeKnowledgeFromCandidate } from "./removeKnowledgeFromCandidate";
import { removePositionWishFromCandidate } from "./removePositionWishToCandidate";
import { updateCandidate } from "./updateCandidate";

export const candidateAPI = {
  addCourseToCandidate,
  getCoursesForCandidate,
  removeCourseFromCandidate,
  addEducationToCandidate,
  getEducationForCandidate,
  removeEducationFromCandidate,
  addExperienceToCandidate,
  getExperienceForCandidate,
  removeExperienceFromCandidate,
  addKnowledgeToCandidate,
  getKnowledgeForCandidate,
  removeKnowledgeFromCandidate,
  removeKnowledgeByTypeFromCandidate,
  updateCandidate,
  getDetailsForCandidate,
  addPositionWishToCandidate,
  removePositionWishFromCandidate,
  editExperienceForCandidate,
  editCourseForCandidate,
  editEducationForCandidate,
  editKnowledgeForCandidate,
  editPositionWishForCandidate,
  attachCandidateToCase,
};

export type CandidateAPI = typeof candidateAPI;
